import React from 'react';

export default function Loading() {
    const logo = window.localStorage.getItem('logo')

    return (

            <section className="container-fluid vertical-center loading" >
                <div className="row mobile-size-option">
                    <div className="col-12 text-center mb-3 px-3 ">
                        <img src={logo} alt="Loading" className='w-50 w-md-25'/>
                    </div>

                    <div className="col-12 text-center ">
                        <div className="spinner-grow text-muted mb-3" role="status">

                        </div>

                    </div>
                </div>
            </section>

    );
}
